exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.parte-cima[data-v-684f6136]{\n\t\tbox-shadow: 5px 3px 6px -6px black;\n\t\tpadding: 1px 5px 2px 20px;\n\t\tbackground-color: #ECF0F1;\n}\n.espaco-lado-lado[data-v-684f6136]{\n\t\tmax-width: 270px;\n\t\twidth: 100%;\n\t\tmargin: 5px 0 5px 0;\n}\n.img[data-v-684f6136]{\n        height: 1.7em;\n}\n.button-cadastrar[data-v-684f6136]{\n        background-color: #27ae60;\n        border-radius: 0.25em !important;\n        color: white;\n        border: none;\n        padding: 0.4em 1em;\n}\n", ""]);

// exports
